import { FileLink } from 'admin/documents/FileLinks';
import _ from 'lodash';
import { useRecordContext } from 'react-admin';

interface FileLinkFieldProps {
  source: string;
  label?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FileLinkField: React.FC<FileLinkFieldProps> = ({ label, source }) => {
  const record = useRecordContext();
  return <FileLink fileId={_.get(record, source)} />;
};
